import React from "react";
import { useAppContext } from "../context/AppContext";
import HomeSmsp from "./HomeSmsp";
import HomeWhiteLabel from "./HomeWhiteLabel";
import SplashScreen from "./SplashScreen";

/** SMSP tenant slug – when organization.slug matches, show the SMSP-branded homepage. */
const SMSP_TENANT_SLUG = "smsp";

/**
 * Renders the homepage for the current tenant. For the SMSP organization (slug from
 * /api/context/current), shows HomeSmsp; for all other tenants, shows HomeWhiteLabel.
 */
const HomePage: React.FC = () => {
    const { organization, loading } = useAppContext();
    const isSmsp = organization?.slug === SMSP_TENANT_SLUG;

    // While context is loading, show white-label to avoid flash of wrong brand
    if (loading) {
        return <SplashScreen loading="Loading application context..." />;
    }

    return isSmsp ? <HomeSmsp /> : <HomeWhiteLabel />;
};

export default HomePage;
